import { Injectable } from '@angular/core'
import { ContactUsList } from '@App/constant/centax-api.constant'
import { HttpHelperService } from '@App/services/http-helper.service'
import { AppUtilityService } from '@App/utility/app-utlility.service'
import { Observable } from 'rxjs'

export interface ContactFormData {
	firstName: string;
	lastName: string;
	mobileNumber: string;
	email: string;
	pinCode: string;
	state: string;
	city: string;
	scheduleCall: string;
	message: string;
  }
  
  export interface LocationData {
	state: string;
	city: string;
  }

@Injectable({
    providedIn: 'root'
  })

export class ContactService {
	constructor(protected httpHelperService: HttpHelperService, protected appUtilityService: AppUtilityService) {}

	getStateAndCity(pinCode:number ) {
		let url = this.appUtilityService.getApiUrl(ContactUsList.GET_STATE_BY_PIN + '/' + pinCode)
        return this.httpHelperService.get(url,true)
    }

	createLead(formData: ContactFormData) {
		 let url = this.appUtilityService.getApiUrl(ContactUsList.CREATE_LEAD)
		return this.httpHelperService.post(url, formData, true)
	}
    
    contactUs(formData: ContactFormData ) {
         let url = this.appUtilityService.getApiUrl(ContactUsList.CONTACT_US_FORM)
        return this.httpHelperService.post(url, formData, true)
    }
}